<template>
    <div class="reg-temp-content-area main-content-height p-3">
        <div class="superadmin-dashboard-area edit-area">
            <loading v-if="loaded == false" />

            <div class="row" v-else>
                <div class="col-sm-12 col-md-7 col-lg-8">
                    <div class="card mb-4">
                        <div class="card-body">
                            <div :class="'registered-product-item mine'">
                                <!-- lets give all access to distributor -->

                                <a class="mb-3 inline-block pointer" @click.prevent="historyBack()"
                                    ><i class="fas fa-long-arrow-alt-left"></i> Back
                                </a>
                                <h3 class="mb-4">Product Details</h3>
                                <ul>
                                    <serial-and-model :data="form" />
                                    <li>
                                        <span class="semibold">Date purchased</span>
                                        <span>
                                            <vuejs-datepicker
                                                initial-view="year"
                                                maximum-view="year"
                                                v-model="form.date_of_purchase"
                                                :typeable="false"
                                                :full-month-name="true"
                                                :format="'yyyy-MM-dd'"
                                                class="input"
                                                id="purchased_date"
                                                placeholder="YYYY-MM-DD"
                                                :disabled-dates="purchaseDisabledDates"
                                            ></vuejs-datepicker>
                                        </span>
                                    </li>

                                    <li>
                                        <span class="semibold">Installation date</span>
                                        <span>
                                            <vuejs-datepicker
                                                initial-view="year"
                                                maximum-view="year"
                                                v-model="form.installation_date"
                                                :typeable="false"
                                                :full-month-name="true"
                                                :format="'yyyy-MM-dd'"
                                                class="input"
                                                id="install_date"
                                                placeholder="YYYY-MM-DD"
                                                :disabled-dates="installationDisabledDates"
                                            ></vuejs-datepicker>
                                        </span>
                                    </li>

                                    <li>
                                        <span class="semibold">Place of purchase</span>
                                        <span><input type="text" v-model="form.place_of_purchase" /></span>
                                    </li>

                                    <li class="border-b-1">
                                        <file-uploader label="Upload proof of purchase" id="proof_of_purchase" :form.sync="form" />
                                    </li>

                                    <li>
                                        <span class="semibold">Installation status</span>
                                        <span class="mt-1 coc-radio d-flex flex-column cursor-pointer">
                                            <label class="mr-2 font-normal" for="with_coc">
                                                <input
                                                    id="with_coc"
                                                    type="radio"
                                                    class="w-auto"
                                                    v-model="form.installation_compliance"
                                                    value="with_coc"
                                                />
                                                Installed with COC
                                            </label>
                                            <label class="mr-2 font-normal" for="without_coc">
                                                <input
                                                    id="without_coc"
                                                    type="radio"
                                                    class="w-auto"
                                                    v-model="form.installation_compliance"
                                                    value="without_coc"
                                                />
                                                Installation delayed
                                            </label>
                                            <label class="mr-2 font-normal" for="no_coc">
                                                <input
                                                    id="no_coc"
                                                    type="radio"
                                                    class="w-auto"
                                                    v-model="form.installation_compliance"
                                                    value="no_coc"
                                                />
                                                No COC
                                            </label>
                                        </span>
                                    </li>
                                    <div v-show="form.installation_compliance == 'with_coc'">
                                        <li>
                                            <span class="semibold">Coc number</span> <span> <input type="text" v-model="form.coc_number" /></span>
                                        </li>
                                        <li>
                                            <file-uploader label="Upload coc certificate" id="coc_certificate" :form.sync="form" />
                                        </li>
                                    </div>

                                    <!-- <li>
                                        <span class="semibold">invoice number:</span> <span> <input type="text" v-model="form.invoice_number" /></span>
                                    </li> -->
                                </ul>
                                <button class="btn btn-primary mt-3" @click.prevent="updateRegProduct()">Submit</button>
                            </div>
                            <ticket-box
                                class="mt-4"
                                :ticket_status="ticket_status"
                                :ticket_type="ticket_type"
                                :tickets="ticketMessages"
                                :form="form"
                            />
                        </div>
                    </div>
                </div>

                <div class="col-sm-12 col-md-5 col-lg-4">
                    <customer-box class="mb-4" v-if="loaded" :productdetail="product_detail" />
                    <reseller-box class="mb-4" v-if="loaded" :productdetail="product_detail" />
                    <TrackingBox :activitydetail="activitydetail" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Env from '@/env';
import AuthApis from '@/controllers/AuthApis';
import Helpers from '@/helpers/index';
import {mapGetters, mapActions} from 'vuex';

import TrackingBox from '@/components/TrackingBox';
import CustomerBox from '@/views/distributor/pageComponents/registerProduct/CustomerBox.vue';
import ResellerBox from '@/views/distributor/pageComponents/registerProduct/ResellerBox.vue';
import moment from 'moment';
import TicketBox from '@/components/WarrantyRepairBox.vue';
import bus from '@/bus';

export default {
    components: {
        TicketBox,
        CustomerBox,
        ResellerBox,
        TrackingBox
    },
    name: 'distributorRegProductEdit',
    data() {
        return {
            activitydetail: [],
            loadCount: 0,
            fetchingMessages: false,
            subscribedChannel: false,
            loaded: false,
            serial_number_max_length: 8,
            ticketMessages: [],

            soldToObj: {},
            soldToSuggestions: [
                {
                    data: []
                }
            ],
            product_detail: {},
            coc_certificate_change: '',
            form: {
                id: '',
                hasOrderNumber: false,
                product_model: '',
                serial_number: '',
                sku_number: '',
                order_number: '',
                sku_with_serial_number: '',
                place_of_purchase: '',
                date_of_purchase: '',
                installation_date: '',
                installation_compliance: 'with_coc',
                coc_number: '',
                coc_certificate: {
                    incoming_url: '',
                    url: '',
                    file: '',
                    name: '',
                    type: '',
                    size: ''
                },
                invoice_number: '',
                sold_to: '',

                proof_of_purchase: {
                    incoming_url: '',
                    url: '',
                    file: '',
                    name: '',
                    type: '',
                    size: ''
                },
                ticket_status: '',
                ticket_type: ''
            }
        };
    },

    watch: {
        // 'form.date_of_purchase': {
        //     handler(newVal) {
        //         if (this.form.installation_date && newVal && this.form.installation_date < newVal) {
        //             this.form.installation_date = null;
        //         } else if (this.form.installation_date && !newVal) {
        //             this.form.installation_date = null;
        //         }
        //     },
        //     deep: true
        // },
        // 'form.installation_date': {
        //     handler(newVal) {
        //         if (this.form.date_of_purchase && newVal && this.form.date_of_purchase > newVal) {
        //             this.form.date_of_purchase = null;
        //         } else if (this.form.date_of_purchase && !newVal) {
        //             this.form.date_of_purchase = null;
        //         }
        //     },
        //     deep: true
        // }
    },
    computed: {
        purchaseDisabledDates() {
            let disabled = {from: new Date()};
            if (this.form.installation_date) {
                const dayAfterInstall = new Date(this.form.installation_date);
                dayAfterInstall.setDate(dayAfterInstall.getDate());
                disabled.from = dayAfterInstall;
            }
            return disabled;
        },
        installationDisabledDates() {
            let disabled = {from: new Date()};

            if (this.form.date_of_purchase) {
                const dayBeforePurchase = new Date(this.form.date_of_purchase);
                dayBeforePurchase.setDate(dayBeforePurchase.getDate());
                disabled.to = dayBeforePurchase;
            }

            return disabled;
        },
        ...mapGetters({
            vg_loggedIn_user_id: 'auth/userid'
        })
    },

    async mounted() {
        let res = await this.fetchProductDetail();
        if (res) {
            this.subscribeProductChannel(res);
        }
        bus.$on('warranty-repair-box-refetch', () => {
            this.fetchProductDetail();
        });
    },

    methods: {
        /**
         * subscribe pubnub
         */
        async subscribeProductChannel(res) {
            if (this.subscribedChannel == false) {
                let channels = [];
                channels.push(res.sku_with_serial_number);
                this.$pnSubscribe({channels: channels});
                this.$pnGetMessage(res.sku_with_serial_number, this.receiveEmit);
                this.subscribedChannel == true;
            }
        },

        receiveEmit(emit) {
            this.fetchProductDetail();
        },

        // /**
        //  * Update sold to
        //  */
        // async updateSoldTo() {
        //   if(_.isEmpty(this.soldToObj)){
        //     return this.$toasted.global.error({
        //       message: 'Please select sold to.'
        //     })
        //   }

        //   const url = `${Env.baseUrl}/distributor/reg-product/update/sold-to/${this.$route.params.id}`;
        //   AuthApis.postApi(url, { sold_to: this.soldToObj.id }).then(res => {
        //     this.$toasted.global.success({
        //       message: 'Successfully updated.'
        //     })
        //   }).catch(err => {
        //     this.$toasted.global.error({
        //       message: err.response.data.errors[0]
        //     })
        //   })

        // },

        /**
         * Update
         */
        updateRegProduct() {
            this.form.sku_with_serial_number = Helpers.getFullSerialNumber(this.form);
            this.form.installation_date = this.form.installation_date ? moment(this.form.installation_date).format('YYYY-MM-DD') : '';
            this.form.date_of_purchase = this.form.date_of_purchase ? moment(this.form.date_of_purchase).format('YYYY-MM-DD') : '';

            if (this.form.date_of_purchase && this.form.installation_date && this.form.installation_date < this.form.date_of_purchase) {
                return this.$toasted.global.error({
                    message: 'Installation date cannot be before date of purchase.'
                });
            }
            this.spinner(true);
            const url = `${Env.baseUrl}/distributor/reg-product/update/${this.form.id}`;

            let formData = new FormData();
            for (let key in this.form) {
                if (key != 'coc_certificate' && key != 'proof_of_purchase') {
                    formData.append(key, this.form[key]);
                }
            }

            if (this.form.coc_certificate.file) {
                // uploadd file to server
                formData.append('coc_certificate', this.form.coc_certificate.file);
            } else if (this.form.coc_certificate.incoming_url == '') {
                // pass blank value to server
                formData.append('coc_certificate', '');
            }

            if (this.form.proof_of_purchase.file) {
                // uploadd file to server
                formData.append('proof_of_purchase', this.form.proof_of_purchase.file);
            } else if (this.form.proof_of_purchase.incoming_url == '') {
                // pass blank value to server
                formData.append('proof_of_purchase', '');
            }

            AuthApis.postApi(url, formData)
                .then((res) => {
                    this.spinner(false);
                    this.$toasted.global.success({
                        message: 'Successfully updated.'
                    });
                    // this.$router.push({ name: 'DistributorRegisteredProducts'});
                })
                .catch((err) => {
                    this.spinner(false);
                    this.$toasted.global.error({
                        message: err.response.data.errors[0]
                    });
                });
        },

        /**
         * Fetch product detail
         */
        async fetchProductDetail() {
            if (this.loadCount < 1) {
                this.loaded = false;
                this.loadCount = 1;
            } else {
                this.fetchingMessages = true;
            }

            const url = `${Env.baseUrl}/distributor/reg-product/show/${this.$route.params.id}`;
            return AuthApis.getApi(url)
                .then(async (res) => {
                    this.ticketMessages = res.data.payload.tickets ? res.data.payload.tickets : [];

                    this.ticket_status = res.data.payload.ticket_status;
                    this.ticket_type = res.data.payload.ticket_type;

                    this.product_detail = res.data.payload;
                    this.form.id = res.data.payload.id;
                    this.form.product_model = res.data.payload.sku_number;
                    this.form.serial_number = res.data.payload.serial_number;
                    this.form.sku_number = res.data.payload.sku_number;
                    this.form.order_number = res.data.payload.order_number;
                    this.form.hasOrderNumber = res.data.payload.order_number ? true : false;

                    this.form.date_of_purchase = res.data.payload.date_of_purchase;
                    this.form.installation_date = res.data.payload.installation_date;

                    this.form.place_of_purchase = res.data.payload.place_of_purchase;
                    this.form.coc_number = res.data.payload.coc_number;

                    this.form.coc_certificate.incoming_url = res.data.payload.coc_certificate;
                    this.form.invoice_number = res.data.payload.invoice_number;

                    this.form.proof_of_purchase.incoming_url = res.data.payload.proof_of_purchase;

                    // Sold to
                    this.form.sold_to = res.data.payload.sold_to ? res.data.payload.sold_to.id : '';
                    this.soldToObj = res.data.payload.sold_to ? res.data.payload.sold_to : {};

                    this.form.installation_compliance = res.data.payload.installation_compliance
                        ? res.data.payload.installation_compliance
                        : 'no_coc';

                    // this.form.purchased_from = res.data.payload.purchased_from ? res.data.payload.purchased_from.id : '';
                    // this.purchasedFromObj = res.data.payload.purchased_from;
                    this.$nextTick(() => {
                        var messageDiv = document.getElementById('display_messages');
                        if (messageDiv) {
                            messageDiv.scrollTop = messageDiv.scrollHeight;
                        }
                    });
                    this.loaded = true;
                    this.fetchingMessages = false;

                    this.activitydetail = res.data.payload.trackings || [];
                    return res.data.payload;
                })
                .catch((err) => {
                    this.loaded = true;
                    return false;
                });
        },

        /**
         *
         * On change serach reftch suggest
         */
        // onChangePurchasedFrom(company) {
        //   this.form.purchased_from = '';
        //   const url = `${Env.baseUrl}/reseller/seller/suggest`;
        //   AuthApis.postApi(url, {
        //     name: company
        //   }).then(res => {
        //     this.purchasedFromSuggestions[0].data = res.data.payload;
        //   }).catch(err => {
        //     console.log(err)
        //   })
        // },

        /**
         *
         * On change serach reftch suggest
         */
        // onChangeSoldTo(company) {
        //   this.form.purchased_from = '';
        //  const url = `${Env.baseUrl}/distributor/customers/suggest`;
        //   AuthApis.postApi(url, {
        //     name: company
        //   }).then(res => {
        //     this.soldToSuggestions[0].data = res.data.payload;
        //   }).catch(err => {
        //     console.log(err)
        //   })
        // },

        /**
         * On click handle seller
         */
        // selectPurchasedFromHandler(obj) {
        //   this.purchasedFromObj = obj.item;
        //   this.form.purchased_from = obj.item.id;
        // },

        // selectSoldToHandler(obj) {
        //   this.soldToObj = obj.item;
        //   this.form.sold_to = obj.item.id;
        // },

        // purchasedFromSuggestionsValue(obj) {
        //   return obj.item.company + ' / ' + obj.item.email;
        // },

        // soldToSuggestionsValue(obj) {
        //   //sold to is customer so always f name
        //   return obj.item.fname + ' / ' + obj.item.email + ' / ' + obj.item.company;
        // },
        showPdf(key) {
            this.va_showPdf(true);

            this.va_setPdfObj({...this.product_detail, ...{target_key: key}});
        },
        historyBack() {
            history.back();
        },

        ...mapActions({
            va_showPdf: 'pdf/setActive',
            va_setPdfObj: 'pdf/setActiveObj'
        })
    },

    beforeDestroy() {
        if (this.product_detail.sku_with_serial_number) {
            let channels = [];
            channels.push(this.product_detail.sku_with_serial_number);
            this.$pnUnsubscribe({channels: channels});
        }
        bus.$off('warranty-repair-box-refetch');
    }
};
</script>
